import { MapPin, Phone, Mail } from "lucide-react";

const LOGO_SVG = "https://customer-assets.emergentagent.com/job_8393e55a-bcbf-4c72-bdaa-a0f6a593df85/artifacts/r7njs9wp_obsidian_bespoke_experiences_hq.svg";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/[0.06]">
      {/* Large brand text */}
      <div className="overflow-hidden py-16 md:py-24">
        <h2 className="font-serif text-white/[0.03] text-[18vw] md:text-[15vw] leading-none tracking-tighter text-center select-none whitespace-nowrap">
          OBSIDIAN
        </h2>
      </div>

      {/* Footer content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 mb-12">
          {/* Brand */}
          <div>
            <img src={LOGO_SVG} alt="Obsidian Bespoke Experiences" className="h-16 w-auto mb-6" style={{filter: "invert(1) brightness(2)"}} />
            <p className="font-sans text-white/40 text-xs leading-relaxed max-w-xs">
              Born from a love for Central American history, landscape and culture.
              We share wonderful moments with visitors in a wholesome and edifying environment.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="font-sans text-[#C5A059] text-[10px] tracking-[0.25em] uppercase mb-4">Explore</p>
            <div className="space-y-3">
              {[
                { label: "Experiences", href: "#experiences" },
                { label: "All-Inclusive", href: "#all-inclusive" },
                { label: "Build Your Own", href: "#bespoke" },
                { label: "Executive Service", href: "#contact" },
              ].map(link => (
                <a key={link.label} href={link.href}
                   className="block font-sans text-white/40 text-sm hover:text-[#C5A059] transition-colors duration-300">
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="font-sans text-[#C5A059] text-[10px] tracking-[0.25em] uppercase mb-4">Contact</p>
            <div className="space-y-3">
              <a href="https://wa.me/50372044528" target="_blank" rel="noopener noreferrer"
                 className="flex items-center gap-3 font-sans text-white/40 text-sm hover:text-[#C5A059] transition-colors">
                <Phone size={14} strokeWidth={1.5} />+503 7204-4528
              </a>
              <a href="mailto:info@obsidianbespoke.com"
                 className="flex items-center gap-3 font-sans text-white/40 text-sm hover:text-[#C5A059] transition-colors">
                <Mail size={14} strokeWidth={1.5} />info@obsidianbespoke.com
              </a>
              <div className="flex items-center gap-3 font-sans text-white/40 text-sm">
                <MapPin size={14} strokeWidth={1.5} />San Salvador, El Salvador
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.06] pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans text-white/35 text-[10px] tracking-wider">
            &copy; {new Date().getFullYear()} Obsidian Bespoke Experiences. All rights reserved.
          </p>
          <p className="font-sans text-white/35 text-[10px] tracking-wider">
            San Salvador, El Salvador, C.A.
          </p>
        </div>
      </div>
    </footer>
  );
}
